<template>
  <div>
    <loading
      :active.sync="isAuthLoading"
      :is-full-page="fullPage"
    />
    
    <ViewModal
      v-show="isModalVisible"
      @close="closeModal"
      @setNameCustomer="setNameCustomer"
    />

    <ViewModalPesquisa
      v-show="isModalPesquisa"
      @close="closeModalPesquisa"
    />

    <v-app
      v-if="!isAuthLoading"
      id="inspire"
      style="background-color: #FAFAFA"
    >
      <v-navigation-drawer
        v-if="!isSignUpPage()"
        app
        dark
        permanent
        :expand-on-hover="!isHomePage || isMobile"
        color="white"
        src="./assets/img/bg.jpg"
      >
        <v-list dense>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img
                src="./assets/img/Logo_Tigre.png"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ $t("titulo") }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ usuario }}
                <small
                  style="cursor: pointer;"
                  @click="logout"
                >({{ $t('sair') }})</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-2" v-if="this.isTigre">
            <v-list-item-content>
              <v-list-item-subtitle>
                <button @click="showModal()">{{this.$i18n.t('trocarCliente')}}</button>
                <small style="margin-left: 5px; color: #fff;"><b>{{ this.nameCustomer }}</b></small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <template>
            <v-list-item @click="showModalPesquisa()">
              <v-list-item-action>
                <v-icon>mdi-magnify</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('busca') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-for="item in mountedMenu()">
            <v-list-item
              v-if="item.target == '_blank'"
              :key="item.text"
              :href="item.link()"
              :target="item.target"
              link
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(item.text) }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="align-self-auto">
                <v-icon x-small>
                  mdi-open-in-new
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item
              v-else-if="!item.children"
              :key="item.text"
              :to="item.link"
              link
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              v-else
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.icon"
              color="white"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t(item.text) }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :href="child.link"
                :target="child.target"
                link
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t(child.text) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-progress-linear
        color="blue darken-4"
        fixed
        indeterminate
        :active="isLoading"
      />
      <AppToast
        :snackbar="toast.snackbar"
        :text="toast.text"
        :color="toast.color"
      />
      <v-main class="background" :class="isHomePage ? 'pa-auto' : 'pl-14'">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
        <v-fab-transition leave-absolute v-if="this.$route.path != '/'">
          <v-btn color="success" fixed fab large dark bottom right :href="linkWhatsapp" target="_blank">
            <v-icon> mdi-whatsapp </v-icon>
          </v-btn>
        </v-fab-transition>
      </v-main>
    </v-app>

    <v-app v-if="!isCountryValid">
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="coutryDialog"
              value="true"
              :retain-focus="false"
              max-width="340"
              persistent
          >
            <v-card>
              <v-toolbar color="red lighten-1" dark>
                <v-icon class="mr-2">mdi-alert-circle</v-icon> País Inválido
              </v-toolbar>
              <v-card-text class="pa-6">
                Verifique sus datos de usuario antes de iniciar sesión, su país de usuario {{this.userCountry }} debiera ser {{expectedCountry}}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-1"
                    text
                    @click="logout()"
                >
                  Redirigir para iniciar sesión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-app>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import EventBus from "./plugins/event-bus";
import { upperCase } from "./helpers/filter";
import utils from '@/utils';
import AppToast from "./components/generic/AppToast";
import config from '@/config';
import axios from 'axios'
import ViewModal from './views/modal/ViewModal.vue';
import ViewModalPesquisa from './views/modal-pesquisa/ViewModalPesquisa.vue';

export default {
  name: 'App',
  components: {
    AppToast,
    Loading,
    ViewModal,
    ViewModalPesquisa
  },
  data () {
    return {
      toast: {
        snackbar: false,
        text: '',
        color: ''
      },
      coutryDialog: false,
      expectedCountry: '',
      isLoading: false,
      isAuthLoading: true,
      fullPage: true,
      usuario: null,
      userCountry: '',
      menu: null,
      isTigre: false,
      isAdministrador: false,
      isAdministradorGlobal: false,
      isModalVisible: false,
      nameCustomer: 'S/N',
      validateUserId: false,
      isModalPesquisa: false,
    }
  },
  async created() {
    this.expectedCountry = config.VUE_APP_COUNTRY
    await this.loadAuth();
    await this.validateUserTigre();
    EventBus.$on("change::isLoading", (loading) => {
      this.isLoading = loading;
    });
    EventBus.$on("criarAlerta", (toast) => {
      this.toast = {...toast};
    });
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    linkWhatsapp() {
      return this.isMobile ? `http://api.whatsapp.com/send?1=es&phone=${this.countryConfig.WHATSAPP}` : `https://web.whatsapp.com/send?1=es&phone=${this.countryConfig.WHATSAPP}`
    },
    isHomePage() {
      return this.$route.name == 'home'
    },
    isCountryValid () {
      return this.userCountry == this.expectedCountry
    },
    countryConfig() {
      return utils.getCountryConfig()
    }
  },
  methods: {
    async validateUserTigre(){
      let country = utils.loadCountry();
      let userid = utils.loadUserId();
      let token = utils.loadToken();

      await axios.get(`${config.VUE_APP_API_URL}venusa/validateUserTigre`, { params: { UNIDADE_PAIS: country, USERID: userid, TOKEN:token } })
      .then(({ data }) => {
        this.isTigre = data.isTigre
        this.isAdministrador = data.isAdministrador
        this.isAdministradorGlobal = data.isAdministradorGlobal
        localStorage.setItem('isAdministrador', data.isAdministrador)
        localStorage.setItem('isAdministradorGlobal', data.isAdministradorGlobal)
        this.menu = this.getMenuCoEc();
        this.nameCustomer = localStorage.getItem('nameCustomer');
        this.customerId = localStorage.getItem('customerId');
      });

    },
    logout() {
      this.$msal.signOut();
      localStorage.clear();
    },
    isSignUpPage(){
      return this.$route.path === "/cadastro";
    }, 
    mountedMenu() {
      return this.menu;
    },
    switchLanguageByCountry() {
      if (!this.isCountryValid) {
        this.coutryDialog = true;
      } else {
        this.$i18n.locale = 'es'
        this.isAuthLoading = false;
      }
    },
    async loadAuth() {
      if (this.$msal.isAuthenticated()){

        if(utils.loadUserId() == ''){
          this.validateUserId = true;
        }  

        let azureb2c = await this.$msal.data.user;
        this.$msal.saveCustomData('userId', azureb2c.accountIdentifier);
        this.$msal.saveCustomData('country', azureb2c.idToken.country);
        this.$msal.saveCustomData('aud', azureb2c.idToken.aud);
        this.userCountry = azureb2c.idToken.country;
        this.switchLanguageByCountry();
        let name = azureb2c.idToken.name;
        let points = name.length > 20 ? "..." : "";
        this.usuario = name.substring(0, Math.min(name.length, 20)) + points;
      } else if (this.isSignUpPage()) {
        this.isAuthLoading = false;
      } else {
        window.history.pushState({}, null, config.VUE_APP_REDIRECT);
        this.$msal.signIn();
      }

      if(this.validateUserId){
        this.saveLogin();
      }
    },
    upperCase,
    getMenuCoEc(){
      if(this.isTigre && (localStorage.getItem('customerId') == null || localStorage.getItem('customerId') == false)){
        return [
          {
            icon: 'mdi-home',
            text: this.$i18n.t('home'),
            link: '/',
          },
        ]
      }

      if(config.VUE_APP_COUNTRY == 'UY'){
      return [
              {
                icon: 'mdi-home',
                text: this.$i18n.t('home'),
                link: '/',
              },
              // {
              //   icon: 'mdi-tag',
              //   text: this.$i18n.t('quotes'),
              //   link: '/quotes'
              // },
              {
                icon: 'mdi-tag',
                text: this.$i18n.t('orders'),
                link: '/orders',
              },
              {
                icon: 'mdi-calendar',
                text: this.$i18n.t('pendingItems'),
                link: '/items',
              },
              {
                icon: 'mdi-compass-outline',
                text: this.$i18n.t('billing'),
                link: '/facturacion',
              },
              { 
                icon: 'mdi-credit-card-check', 
                text: this.$i18n.t('creditLimit'), 
                link: '/credito' 
              },
              // {
              //   icon: 'mdi-currency-usd',
              //   text: this.$i18n.t('eletronicBill'),
              //   link: () => this.countryConfig.FACTURAS_URL,
              //   target: '_blank'
              // }, 
              {
                icon: 'mdi-book-open-page-variant',
                text: this.$i18n.t('catalog'),
                link: () => this.countryConfig.CATALOG_URL,
                target: '_blank'
              },
              {
                icon: 'mdi-help-circle-outline',
                text: this.$i18n.t('centroAyuda'),
                link: '/centro-ayuda',
              },
              {
                icon: 'mdi-view-dashboard',
                text: this.$i18n.t('DashBoard Indicadores'),
                link: '/indicadores-financeiros',
              },
              this.mountMenuAdministrador(),
            ]
      }

      return [
        {
          icon: 'mdi-home',
          text: this.$i18n.t('home'),
          link: '/',
        },
        {
          icon: 'mdi-magnify',
          text: this.$i18n.t('busca'),
          link: '#',
        },
        // {
        //   icon: 'mdi-tag',
        //   text: this.$i18n.t('quotes'),
        //   link: '/quotes'
        // },
        {
          icon: 'mdi-tag',
          text: this.$i18n.t('orders'),
          link: '/orders',
        },
        {
          icon: 'mdi-calendar',
          text: this.$i18n.t('pendingItems'),
          link: '/items',
        },
        {
          icon: 'mdi-compass-outline',
          text: this.$i18n.t('billing'),
          link: '/facturacion',
        },
        { 
          icon: 'mdi-credit-card-check', 
          text: this.$i18n.t('creditLimit'), 
          link: '/credito' 
        },
        {
          icon: 'mdi-currency-usd',
          text: this.$i18n.t('eletronicBill'),
          link: () => this.countryConfig.FACTURAS_URL,
          target: '_blank'
        }, 
        {
          icon: 'mdi-book-open-page-variant',
          text: this.$i18n.t('catalog'),
          link: () => this.countryConfig.CATALOG_URL,
          target: '_blank'
        },
        {
          icon: 'mdi-help-circle-outline',
          text: this.$i18n.t('centroAyuda'),
          link: '/centro-ayuda',
        },
        {
          icon: 'mdi-view-dashboard',
          text: this.$i18n.t('DashBoard Indicadores'),
          link: '/indicadores-financeiros',
        },
        this.mountMenuAdministrador(),
      ]
    },
    showModal() {
        this.isModalVisible = true;
    },
    showModalPesquisa() {
        this.isModalPesquisa = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalPesquisa() {
      this.isModalPesquisa = false;
    },
    setNameCustomer(){
      this.nameCustomer = localStorage.getItem('nameCustomer');
      this.customerId = localStorage.getItem('customerId');
      this.menu = this.getMenuCoEc();
    },
    mountMenuAdministrador(){
      if(this.isAdministrador || this.isAdministradorGlobal){
        return {
          icon: 'mdi-database',
          text: this.$i18n.t('Dashboard navegação'),
          link: '/dash-indicadores',
        }
      }else{
        return {}
      }
    },
    saveLogin(){
      let country = utils.loadCountry();
      let userid = utils.loadUserId();
      let token = utils.loadToken();

      axios.post(`${config.VUE_APP_API_URL}venusa/saveLoginUser`, { UNIDADE_PAIS: country, USERID: userid, TOKEN:token });
    }
  }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>